export default __webpack_public_path__ + "static/media/noPain.248515e3.svg";